import { render, staticRenderFns } from "./flg-frame.vue?vue&type=template&id=24835a59"
import script from "./flg-frame.vue?vue&type=script&lang=js"
export * from "./flg-frame.vue?vue&type=script&lang=js"
import style0 from "./flg-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/flg/flg-frame.vue
// module id = TXPk
// module chunks = 0